var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconInMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4143 14.8285C15.2653 14.8082 15.1308 14.9281 15.1135 15.0951C15.0961 15.2622 15.2024 15.4135 15.3509 15.433C18.2009 15.8097 19.7188 16.825 19.7188 17.4133C19.7188 18.2392 16.832 19.3914 12.1304 19.3914C7.42888 19.3914 4.54203 18.2392 4.54203 17.4133C4.54203 16.825 6.05998 15.8097 8.90997 15.433C9.05849 15.4135 9.16472 15.2619 9.14738 15.0951C9.12976 14.9281 8.99534 14.8076 8.84655 14.8285C5.99304 15.2059 4 16.2687 4 17.4133C4 18.6988 6.7928 20.0001 12.1304 20.0001C17.4681 20.0001 20.2609 18.6988 20.2609 17.4133C20.2609 16.2687 18.2678 15.2059 15.4143 14.8285Z",
    fill: "#99C540"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1305 18.5217L16.2699 12.241C17.8224 10.0665 17.5979 6.4923 15.7893 4.59251C14.812 3.56551 13.5125 3 12.1305 3C10.7484 3 9.44897 3.56551 8.47167 4.59223C6.66304 6.49202 6.43854 10.0662 7.98491 12.2322L12.1305 18.5217ZM12.1783 6.40159C13.2198 6.40159 14.067 7.29196 14.067 8.38585C14.067 9.47975 13.2198 10.3701 12.1783 10.3701C11.1367 10.3701 10.2895 9.47975 10.2895 8.38585C10.2895 7.29196 11.1367 6.40159 12.1783 6.40159Z",
    fill: "#99C540"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInMap);
export default __webpack_public_path__ + "static/media/icon_in_map.dfd90a35c328ffc0bf71a48e6c5e5015.svg";
export { ForwardRef as ReactComponent };